export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-shrink-0 w-full lg:w-[380px]">
            <div className="relative aspect-[9/16] max-w-[280px] mx-auto rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20a%20modern%20movie%20streaming%20app%20interface%20with%20film%20posters%20and%20play%20buttons%2C%20clean%20dark%20UI%20design%2C%20cinematic%20color%20scheme%2C%20minimalist%20layout%2C%20on%20a%20warm%20wooden%20desk%20with%20soft%20ambient%20light%2C%20product%20photography%2C%20sleek%20and%20modern&width=560&height=996&seq=mobile-app-mv-2026&orientation=portrait"
                alt="蘑菇影视移动端观影"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">移动观影</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0">
              蘑菇影视移动端适配完美，无论您使用手机还是平板，均可享受高清、超清乃至4K蓝光画质的流畅观影体验。随时随地打开即看，无广告打扰，播放稳定不缓冲，让每一段碎片时间都成为高品质的观影时光。支持横屏沉浸模式和竖屏快捷操作，观影体验不输大屏。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-lg">
                <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">手机适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-lg">
                <i className="ri-tablet-line text-primary-500 text-lg"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">平板优化</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-lg">
                <i className="ri-wifi-line text-primary-500 text-lg"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">自适应码率</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}